export default "__VITE_ASSET__CiQtUxR8__"